import React from 'react';
import './PageStyles.css';

function Terms() {
  return (
    <div className="page">
      <h1>📄 Terms & Conditions</h1>

      <p>
        By accessing or using the <strong>TestYodha</strong> mobile app or website, you agree to be legally bound by these Terms and Conditions.
      </p>

      <h2>📌 Subscriptions</h2>
      <p>
        Subscriptions are course-specific and time-bound. Access will remain active only for the selected course and duration.
      </p>

      <h2>🔐 Content Usage</h2>
      <p>
        All content provided within the app is copyrighted. Unauthorized sharing, downloading, screen recording, or redistribution of content is strictly prohibited.
      </p>

      <h2>🚫 Misuse & Suspension</h2>
      <p>
        Any misuse of platform features, manipulation of test attempts, or violation of academic integrity may result in temporary or permanent suspension of your account without prior notice.
      </p>

      <h2>🛠️ Changes to Terms</h2>
      <p>
        TestYodha reserves the right to update these Terms at any time. Continued use of the platform after changes implies your acceptance of the revised Terms.
      </p>

      <hr style={{ margin: '40px auto', width: '60%', borderColor: '#444' }} />

      <p style={{ fontStyle: 'italic', color: '#25292e' }}>
        For any queries related to terms or account usage, feel free to contact us at  
        <a href="mailto:testyodha3@gmail.com" style={{ color: '#0047ab', textDecoration: 'none' }}> testyodha3@gmail.com</a>
      </p>
    </div>
  );
}

export default Terms;